/* eslint-disable */

import { useMemo, useEffect, useState, useCallback } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { get } from '../../http/restservice'
import { Link, useNavigate } from 'react-router-dom'
import env from '../../env/env'
import PlansCarousel from '../../Components/Home/PlansCarousel'
import useMediaQuery from '../../hooks/useMediaQuery'
import { getUserDetails } from '../../utils/AuthUtil'

//SVGS to upload
import insurance from '../../assets/newHome/insurance.svg'
import taxPlanning from '../../assets/newHome/taxPlanning.svg'

import { useRecoilRefresher_UNSTABLE, useRecoilValueLoadable } from 'recoil'
import { GetAllMandates, MFBasketHoldings, MFUserBaskets } from '../../store/MFBasketsStore'
import { Skeleton } from '../../Components/ui/skeleton'
import { BasketRebalancing, MutualFundsHolding } from '../../store/MFStore'
import { CheckIcon, MoveRight, PieChart } from 'lucide-react'
import { HomeCarouselCards } from '../../store/HomePageStore'
import { MFUserSubsequentBaskets } from '../../store/MFBasketsStore'
import InProgressOrdersComponent from '../../Components/Home/InProgressOrders'
import { ALLOWED_UIDS } from '../../config/allowedUIDs'
import PostHogTracker from '../../utils/PostHogTracker'
import { Badge } from '../../Components/ui/badge'
import { StoriesFeed } from '../../Components/StoriesFeed/StoriesFeed'
import GlanceStats from '../../Components/Home/GlanceStats'
import { Dialog, DialogHeader, DialogTitle, DialogClose, DialogDescription, DialogContent, DialogFooter } from '../../Components/ui/dialog'
import { Button } from '../../Components/ui/button'


// Animation variants
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 20,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.25,
      ease: 'easeOut',
    },
  },
  hover: {
    scale: 1.02,
    y: -4,
    transition: {
      duration: 0.2,
      ease: 'easeInOut',
    },
  },
  tap: {
    scale: 0.98,
    transition: {
      duration: 0.1,
    },
  },
}

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
      delayChildren: 0.05,
    },
  },
}

const Card = ({ title, desc, gradient, icon: Icon, onClick, topCard, bottomCard }) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)')
  const [isHovered, setIsHovered] = useState(false)

  return (
    <motion.div
      className={`h-full `}
      style={{
        border: gradient ? '1px solid transparent' : '',
        borderRadius: '16px',
        background: gradient
          ? 'linear-gradient(white, white) padding-box, linear-gradient(93.32deg, rgba(31, 160, 230, 0.8) 0%, rgba(236, 41, 197, 0.8) 49.96%, rgba(236, 127, 38, 0.8) 99.91%) border-box'
          : '#F4F7FE',
        outline: `${isHovered && !gradient ? '1px solid #D3DBEC' : 'none'}`,
      }}
      variants={cardVariants}
      whileHover='hover'
      whileTap='tap'
    >
      <div
        className={`flex-1 p-4 cursor-pointer h-full ${gradient && 'lg:flex lg:flex-col lg:items-center lg:justify-center'
          }`}
        style={{
          background: gradient
            ? 'linear-gradient(92.56deg, rgba(31, 160, 230, 0.08) 3.63%, rgba(236, 41, 197, 0.08) 47.06%, rgba(236, 127, 38, 0.08) 90.49%), #FFFFFF'
            : '#F4F7FE',
          // boxShadow: '0px 6px 16px rgba(239, 149, 80, 0.12)',
          borderRadius: '16px',
        }}
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <motion.div
          className='flex justify-between items-center'
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.1, duration: 0.2 }}
        >
          <h1
            className={`text-lg font-medium flex items-center gap-x-2 ${gradient &&
              'pb-2 bg-gradient-to-r from-purple-500 via-pink-500 to-pink-400 bg-clip-text text-transparent lg:font-medium lg:justify-center lg:text-[32px]'
              } ${topCard && !gradient && 'lg:text-2xl'} ${bottomCard && '!text-base lg:!text-xl'}`}
          >
            {Icon && (
              <motion.div
                initial={{ rotate: -180, opacity: 0 }}
                animate={{ rotate: 0, opacity: 1 }}
                transition={{ delay: 0.15, duration: 0.25 }}
              >
                <Icon className='h-6 w-6' />
              </motion.div>
            )}
            {title}
          </h1>
          {isDesktop && !gradient && (
            <motion.div
              initial={{ opacity: 0, x: 10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2, duration: 0.2 }}
            >
              <ChevronRightIcon sx={{ color: '#9E9E9E' }} />
            </motion.div>
          )}
        </motion.div>
        {desc && (
          <motion.p
            className={`text-sm mt-2 font-normal ${gradient
              ? 'bg-gradient-to-r from-blue-400 via-pink-400 to-pink-300 bg-clip-text text-transparent'
              : 'text-black-400 '
              } ${topCard ? 'lg:mt-4' : 'lg:mt-3'}`}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.25, duration: 0.2 }}
          >
            {desc}
          </motion.p>
        )}
      </div>
    </motion.div>
  )
}

const KycUserHomePage = () => {
  const navigate = useNavigate()
  const isDesktop = useMediaQuery('(min-width: 1024px)')
  const [loginDetails, setLoginDetails] = useState({})
  const [isFICompleted, setIsFICompleted] = useState(false)
  const [adminPlans, setAdminPlans] = useState([])
  const [activeAdminPlans, setActiveAdminPlans] = useState([])
  const [showStoriesFeed, setShowStoriesFeed] = useState(false)
  const { state: mandatesState, contents: mandates } = useRecoilValueLoadable(GetAllMandates)

  const subsequentPlans = useRecoilValueLoadable(MFUserSubsequentBaskets)
  const { state: mfbasketState, contents: investedPlans } = useRecoilValueLoadable(MFUserBaskets)
  const refreshPlans = useRecoilRefresher_UNSTABLE(MFUserBaskets)
  const mfHolding = useRecoilValueLoadable(MutualFundsHolding)
  const orders = useRecoilValueLoadable(MFBasketHoldings)
  const carouselCards = useRecoilValueLoadable(HomeCarouselCards)
  const rebalancing = useRecoilValueLoadable(BasketRebalancing)

  const POPUP_KEY = 'openRebalancingPopup'

  const [openRebalancingPopup, setOpenRebalancingPopup] = useState(false)

  useEffect(() => {

    // if (rebalancing?.contents?.message?.includes("No basket sip rebalancing found")) {
    //   return
    // }

    const isClosed = sessionStorage.getItem(POPUP_KEY)

    if (
      rebalancing?.state === 'hasValue' &&
      rebalancing?.contents?.data?.length > 0 &&
      rebalancing?.contents?.data?.some((p) => p.rebalanceStatus === "REQUIRED")
      &&
      isClosed !== 'true'
    ) {

      setOpenRebalancingPopup(true)
    }
  }, [rebalancing])




  const uid = loginDetails?.uid?.toUpperCase()
  const isAllowed = ALLOWED_UIDS?.some((id) => uid?.includes(id))
  const [elogStatuses, setElogStatuses] = useState({})




  useEffect(() => {
    const fetchKycNumber = async () => {
      // console.log(userDetails?.phoneNumber, 'userDetails?.phoneNumber')
      if (!loginDetails?.phoneNumber) return

      // try {
      // const kycNumber = await fetchCustomerKycDetails(loginDetails?.phoneNumber)

      // console.log(kycNumber, 'kycNumber')

      // if (kycNumber) {
      let elgStatus = await fetchCustomerKycStatuses(loginDetails?.phoneNumber)


      if (elgStatus) {
        setElogStatuses(elgStatus)
      }
      // }
      // } catch (error) {
      //   console.error('Error fetching KYC details:', error)
      // }
    }

    fetchKycNumber()
  }, [loginDetails])





  // const fetchCustomerKycDetails = async (phNum) => {
  //   const phNo = '%2b91' + phNum?.replace(/^(\+91\s?)/, '')
  //   const response = await get(`${env.API_URL}customerservice/api/customer?phoneNumber=${phNo}`)

  //   if (!response || response?.isError) {
  //     return null
  //   }

  //   if (!response?.isError && response) {
  //     const kycPhone = response?.kycPhoneNumber
  //     return kycPhone
  //   }
  // }

  const fetchCustomerKycStatuses = async (phNum) => {
    const phNo = '%2b91' + phNum?.replace(/^(\+91\s?)/, '')

    const response = await get(
      `${env.API_URL}customerservice/api/customer/fetchCustomerKycStatuses?kycPhoneNumber=${phNo}`,
    )



    if (response?.isError) {
      return null
    }

    if (!response?.isError) {

      return response
    }
  }

  useEffect(() => refreshPlans(), [])

  useEffect(() => {
    if (mfbasketState === 'hasValue' && Array.isArray(investedPlans?.data)) {
      const adminCuratedPlans = investedPlans?.data?.filter(
        (plan) =>
          plan.createdSource === 'ACTION PLAN' &&
          (plan?.sipStatus === 'PENDING' || plan?.oneTimeStatus === 'PENDING'),
      )

      const activeAdminPlans = investedPlans?.data?.filter(
        (plan) =>
          plan.createdSource === 'ACTION PLAN' &&
          (plan?.sipStatus === 'ACTIVE' || plan?.oneTimeStatus === 'ACTIVE'),
      )

      setActiveAdminPlans(activeAdminPlans)

      setAdminPlans(adminCuratedPlans)
    }
  }, [mfbasketState, investedPlans?.data])


  const cards = [

    {
      id: 1,
      title: elogStatuses?.uccRegistered && !elogStatuses?.elogDone ? 'You’re almost there! 🚀' : 'Start here',
      desc: elogStatuses?.uccRegistered && !elogStatuses?.elogDone ? 'Just one final step to activate your account and continue investing.' : 'Discover your perfect fund in a few taps',
    },
    {
      id: 2,
      title:
        !adminPlans?.length && !activeAdminPlans?.length && isFICompleted
          ? 'Curating your plans...'
          : 'You are all set',
      desc: 'We will get in touch with you soon',
    },
    {
      id: 3,
      title: 'Action Center',
      desc: 'Proceed with your plans',
    },
    {
      id: 4,
      title: (
        <div className='flex gap-x-[10px] items-center m-2'>
          <PieChart className='h-8 w-8' />
          <p className='flex items-center gap-2'>
            Portfolio Overview
            <Badge variant='outline' className="lg:hidden">NEW</Badge>
          </p>
        </div>

      ),
      desc: 'Analyze your investments with allocation insights',
    },

    {
      id: 5,
      title: (
        <div className='flex gap-x-[10px] items-center m-2'>
          <img src={`${env.S3_BASE_URL}/firstTime/analytics.svg`} height={32} width={32} />
          <p className='flex items-center gap-2'>
            2025 Performance
            <Badge variant='outline' className="lg:hidden">NEW</Badge>
          </p>        </div>
      ),
      desc: 'Fabits has outperformed it’s benchmarks with lower volatility',
    },


    // {
    //   id: 5,
    //   title: (
    //     <div className='block gap-x-[10px] items-center'>
    //       <TrackChangesIcon sx={{ height: '32px', width: '32px' }} />
    //       <p>Goal Planning</p>
    //     </div>
    //   ),
    //   desc: 'Start saving for life’s bigger financial responsibilities',
    // },

    {
      id: 6,
      title: (
        <div className='flex gap-x-[10px] items-center m-2'>
          <img src={insurance || '/placeholder.svg'} height={32} width={32} />
          <p>Insurance</p>
        </div>
      ),
      desc: 'Identify coverage gaps with policy reviews',
    },
    {
      id: 7,
      title: (
        <div className='flex gap-x-[10px] items-center m-2'>
          <img src={taxPlanning || '/placeholder.svg'} height={32} width={32} />
          <p>Tax Planning</p>
        </div>
      ),
      desc: 'Personalised tax planning to maximise deductions and savings',
    },


  ]

  const getTopCards = () => {
    const filteredCards = []


    if (elogStatuses?.uccRegistered && !elogStatuses?.elogDone) {
      filteredCards.push(cards[0])
      return filteredCards
    }


    if (
      !isFICompleted &&
      adminPlans?.length === 0 &&
      subsequentPlans?.state === 'hasValue' &&
      subsequentPlans?.contents?.data?.length === 0 &&
      (mfHolding?.contents?.mainData?.length === 0 || mfHolding?.contents?.length === 0) && (mandatesState === 'hasValue' && mandates?.data?.length >= 0 && mandates?.data?.some(mandate => mandate?.mandateStatus !== 'REQUESTED'))
    ) {
      filteredCards.push(cards[0])
      return filteredCards

    }



    if (
      isFICompleted &&
      adminPlans?.length === 0 &&
      subsequentPlans?.state === 'hasValue' &&
      subsequentPlans?.contents?.data?.length === 0 &&
      (mfHolding?.contents?.mainData?.length === 0 || mfHolding?.contents?.length === 0) && (mandatesState === 'hasValue' && mandates?.message?.includes("No mandate found"))
    ) {
      filteredCards.push(cards[1])
      return filteredCards

    }


    if (
      adminPlans?.length > 0 ||
      (subsequentPlans?.state === 'hasValue' && subsequentPlans?.contents?.data?.length > 0) || (mandatesState === 'hasValue' && mandates?.data?.length > 0 && mandates?.data?.some(mandate => mandate?.mandateStatus === 'REQUESTED'))
    ) {
      filteredCards.push(cards[2])
      return filteredCards

    }



    return filteredCards
  }

  const topCards = getTopCards()

  console.log("topCards", topCards)

  const topCardsDesktop = useMemo(() => topCards, [topCards])

  const bottomCards = useMemo(
    () => cards.slice(mfHolding?.contents?.mainData?.length === 0 ? 4 : 3),
    [mfHolding?.contents?.mainData],
  )

  const bottomCardsDesktop = useMemo(
    () => cards.slice(mfHolding?.contents?.mainData?.length === 0 ? 4 : 3),
    [mfHolding?.contents?.mainData],
  )

  const isQuestionaireCompleted = useCallback(
    async (phoneNumber) => {
      const url = `${env.API_URL}customerservice/api/firstIdeas`

      try {
        const response = await get(url, {}, { phoneNumber })
        if (response?.isCompleted) {
          setIsFICompleted(true)
        }
      } catch (error) {
        console.log(error)
      }
    },
    [loginDetails?.phoneNumber],
  )

  useEffect(() => {
    const initializeUserDetails = () => {
      const userDetails = getUserDetails()
      setLoginDetails(userDetails)

      if (userDetails?.phoneNumber) {
        isQuestionaireCompleted(userDetails?.phoneNumber)
      }
    }

    initializeUserDetails()
  }, [])

  const redirect = (id, title) => {
    if (id === 1) {
      elogStatuses?.uccRegistered && !elogStatuses?.elogDone ? navigate('/dashboard/start-kyc', {
        state: {
          isElogDone: false,
        },
      })
        : navigate('/dashboard/firstTime/questionnaire')
    } else if (id === 2) {
      return
    } else if (id === 3) {
      // elogStatuses?.uccRegistered && !elogStatuses?.elogDone ? navigate('/dashboard/start-kyc', {
      //   state: {
      //     isElogDone: false,
      //   },
      // })
      //   : 
      navigate('/dashboard/firstTime/actionPlanUser')
    } else if (id === 4) {
      navigate('/dashboard/portfolio-allocation')
    } else if (id === 5) {
      setShowStoriesFeed(true)
    } else if (id === 6) {
      PostHogTracker.insurancePlanViewed('General', 'Ditto')
      navigate('/dashboard/insurance')
    } else if (id === 7) {
      navigate('/dashboard/tax-filing')
    }
  }

  const getCurrentInvestmentTotal = () => {
    let investment

    if (loginDetails?.uid?.toUpperCase().includes('FAB0100')) {
      investment =
        orders.state === 'hasValue' && orders?.contents?.holdings?.length > 0
          ? orders?.contents?.holdings
            .reduce((sum, item) => sum + item.currentNav * item.netUnits, 0)
          : 0
    } else {
      investment =
        mfHolding.state === 'hasValue' && mfHolding?.contents?.mainData?.length > 0
          ? mfHolding?.contents?.mainData
            ?.filter((item) => item?.isOutsideData === 0)
            .reduce((sum, item) => sum + Number(item.holding), 0)
          : 0
    }

    const total = investment

    return total.toFixed(2)
  }

  const getCurrentInvestedTotal = () => {
    let investment

    if (loginDetails?.uid?.toUpperCase().includes('FAB0100')) {
      investment =
        orders.state === 'hasValue' && orders?.contents?.holdings?.length > 0
          ? orders?.contents?.holdings
            .reduce((sum, item) => sum + Number(item.netInvestedAmount), 0)
          : 0
    } else {
      investment =
        mfHolding.state === 'hasValue' && mfHolding?.contents?.mainData?.length > 0
          ? mfHolding?.contents?.mainData
            ?.filter((item) => item?.isOutsideData === 0)
            .reduce((sum, item) => sum + Number(item.netInvestedAmt), 0)
          : 0
    }

    const total = investment

    return total.toFixed(2)
  }

  const calculateParcentage = (invested, returns) => {
    const result = ((returns - invested) / invested) * 100
    return result.toFixed(2)
  }

  // Track investment amounts in PostHog when portfolio data is loaded
  useEffect(() => {
    const trackInvestmentMetrics = () => {
      // Check if we have valid holdings data
      const hasValidData = loginDetails?.uid?.toUpperCase().includes('FAB0100')
        ? orders.state === 'hasValue' && orders?.contents?.holdings?.length > 0
        : mfHolding.state === 'hasValue' && mfHolding?.contents?.mainData?.length > 0

      if (hasValidData && loginDetails?.uid) {
        const totalInvested = parseFloat(getCurrentInvestedTotal())
        const currentValue = parseFloat(getCurrentInvestmentTotal())
        const returns = currentValue - totalInvested
        const returnPercentage = totalInvested > 0 ? ((returns / totalInvested) * 100).toFixed(2) : 0

        // Track portfolio summary viewed event
        PostHogTracker.portfolioSummaryViewed(currentValue, totalInvested, parseFloat(returnPercentage))

        // Update PostHog user properties with investment metrics
        PostHogTracker.updateUserProfile({
          total_invested_amount: totalInvested,
          current_portfolio_value: currentValue,
          total_returns: returns,
          return_percentage: parseFloat(returnPercentage),
          has_investments: totalInvested > 0,
          portfolio_count: loginDetails?.uid?.toUpperCase().includes('FAB0100')
            ? orders?.contents?.holdings?.length
            : mfHolding?.contents?.mainData?.length,
          last_portfolio_update: new Date().toISOString(),
        })
      }
    }

    trackInvestmentMetrics()
  }, [mfHolding, orders, loginDetails?.uid])


  const [isNonFabitsExpanded, setIsNonFabitsExpanded] = useState(true)

  // Get non-fabits assets data
  const getNonFabitsAssets = useMemo(() => {
    if (mfHolding?.state === 'hasValue' && mfHolding?.contents?.mainData?.length > 0) {
      const nonFabitsAssets = mfHolding.contents.mainData.filter(
        (item) => item?.isOutsideData === 1 && Number(item?.balance) > 0 && item?.isincd,
      )

      if (nonFabitsAssets.length === 0) return null

      // Group by ISIN
      const groupedByISIN = {}
      nonFabitsAssets.forEach((item) => {
        const isin = item?.isincd
        if (!isin) return

        if (!groupedByISIN[isin]) {
          groupedByISIN[isin] = { ...item }
        } else {
          groupedByISIN[isin] = {
            ...groupedByISIN[isin],
            balance: (groupedByISIN[isin].balance || 0) + (item.balance || 0),
            netInvestedAmt: (groupedByISIN[isin].netInvestedAmt || 0) + (item.netInvestedAmt || 0),
            holding: (groupedByISIN[isin].holding || 0) + (item.holding || 0),
          }
        }
      })

      const groupedAssets = Object.values(groupedByISIN)

      const totalInvested = groupedAssets.reduce(
        (sum, item) => sum + (Number(item.netInvestedAmt) || 0),
        0,
      )
      const totalCurrent = groupedAssets.reduce((sum, item) => sum + (Number(item.holding) || 0), 0)
      const returns = totalCurrent - totalInvested
      const returnsPercentage = totalInvested > 0 ? ((returns / totalInvested) * 100).toFixed(2) : 0

      return {
        assets: groupedAssets,
        totalInvested,
        totalCurrent,
        returns,
        returnsPercentage,
      }
    }
    return null
  }, [mfHolding])


  return (
    <>

      <Dialog open={openRebalancingPopup} onOpenChange={(val) => {
        setOpenRebalancingPopup(val)

        if (!val) {
          sessionStorage.setItem(POPUP_KEY, 'true')
        }
      }}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className='text-center font-semibold text-xl font-DMSans'>Rebalancing required</DialogTitle>
          </DialogHeader>
          <DialogDescription className='text-start text-black-400 font-medium text-sm'>
            Rebalancing is the process of adjusting your portfolio to maintain the right asset allocation based on your goals and risk profile.
          </DialogDescription>
          <DialogFooter className='mb-safe flex flex-col gap-y-2'>
            <Button
              onClick={() => {
                setOpenRebalancingPopup(false)
                sessionStorage.setItem(POPUP_KEY, 'true')

              }} className='w-full bg-error-500 text-white hover:bg-error-600'>Exit</Button>
            <Button

              onClick={() => {
                sessionStorage.setItem(POPUP_KEY, 'true')

                navigate("/dashboard/firstTime/actionPlanUser", {
                  state: {
                    action: "rebalancing"
                  }

                })
              }} className='w-full bg-primary-500 text-white hover:bg-primary-600'>Continue</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>


      {showStoriesFeed && (
        <StoriesFeed
          autoOpen={true}
          onClose={() => setShowStoriesFeed(false)}
        />
      )}

      <InProgressOrdersComponent />

      <motion.div
        className='bg-white h-full px-4 lg:px-0 py-4 flex flex-col gap-4 lg:mx-auto lg:max-w-[1128px]'
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <AnimatePresence>
          {(mfHolding?.contents?.mainData?.length === 0 || mfHolding?.contents?.length === 0) && (
            <motion.div
              className='mb-10'
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1, duration: 0.3 }}
            >
              <motion.h1
                className='font-OrelegaOne font-normal text-2xl'
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2, duration: 0.25 }}
              >
                Start building your empire today!
              </motion.h1>
              <motion.div
                className='font-DMSans font-normal text-base mt-3'
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3, duration: 0.25 }}
              >
                <p className='flex items-center gap-2 text-black-600 cursor-pointer'>
                  Your KYC is all set{' '}
                  <motion.span
                    className='bg-secondary-600 text-white rounded-full flex items-center justify-center p-0.5'
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ delay: 0.4, duration: 0.2, type: 'spring' }}
                  >
                    <CheckIcon className='h-3 w-3' />
                  </motion.span>
                </p>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>

        <motion.div
          className={`flex flex-col lg:flex-row lg:items-stretch gap-4 lg:max-w-[1128px] lg:min-h-[160px]`}
          variants={containerVariants}
          initial='hidden'
          animate='visible'
        >
          {/* AT A Glance section */}
          {
            <>
              {mfHolding.state === 'hasValue' &&
                mfHolding.state !== 'hasError' ? (
                <div className='flex-[3]'>
                  <GlanceStats cardVariants={cardVariants} loginDetails={loginDetails} orders={orders} mfHolding={mfHolding} />
                </div>
              ) : (
                <>
                  {mfHolding.state === 'loading' && (
                    <>
                      <motion.div
                        className='rounded-3xl border p-8 flex-[2] mx-auto hidden lg:block'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className='flex justify-between items-center mb-8'>
                          <h2 className='text-primary-300 font-medium text-sm mb-3'>AT A GLANCE</h2>
                          <div className='flex items-center gap-2'>
                            <Skeleton className='h-4 w-28' />
                            <Skeleton className='h-4 w-4 rounded-full' />
                          </div>
                        </div>

                        <div className='flex justify-between ga-x-8'>
                          {/* Current Value */}
                          <div className='space-y-2'>
                            <div className='flex items-center gap-2'>
                              <Skeleton className='h-8 w-40' />
                              <Skeleton className='h-6 w-6 rounded-full' />
                            </div>
                            <Skeleton className='h-5 w-32' />
                          </div>

                          {/* Invested Amount */}
                          <div className='space-y-2'>
                            <Skeleton className='h-8 w-32' />
                            <Skeleton className='h-5 w-40' />
                          </div>

                          {/* Returns */}
                          <div className='space-y-2'>
                            <div className='flex items-center gap-2'>
                              <Skeleton className='h-8 w-24' />
                              <Skeleton className='h-6 w-6 rounded-full' />
                            </div>
                            <Skeleton className='h-5 w-20' />
                          </div>
                        </div>
                      </motion.div>

                      <motion.div
                        className='rounded-3xl border p-5 w-full mx-auto lg:hidden'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        {/* Main Value - Centered at top */}
                        <div className='flex justify-center mb-10'>
                          <Skeleton className='h-9 w-40' />
                        </div>

                        {/* Two column layout for bottom values */}
                        <div className='grid grid-cols-2 gap-4'>
                          {/* Invested Amount - Left */}
                          <div className='space-y-2'>
                            <Skeleton className='h-8 w-24' />
                            <Skeleton className='h-5 w-20' />
                          </div>

                          {/* Returns - Right */}
                          <div className='flex flex-col items-end space-y-2'>
                            <div className='flex items-center gap-2'>
                              <Skeleton className='h-8 w-20' />
                              <Skeleton className='h-6 w-6 rounded-full' />
                            </div>
                            <Skeleton className='h-5 w-16' />
                          </div>
                        </div>
                      </motion.div>
                    </>
                  )}
                </>
              )}
            </>
          }

          {isAllowed && (
            <Link
              to={`/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/actionPlan`}
              className='text-blue-500 hover:text-blue-700 px-1 lg:hidden flex items-center gap-x-1'
            >
              Create Action Plan For Customer <MoveRight className='w-4 h-4' />
            </Link>
          )}

          {mfbasketState === 'hasValue' && mfbasketState !== 'hasError' ? (
            <motion.div
              className={`flex-1 ${mfHolding?.contents?.mainData?.length === 0 && 'flex md:flex-row flex-col gap-4'
                }`}
              variants={containerVariants}
            >
              <AnimatePresence>
                {(isDesktop ? topCardsDesktop : topCards)?.map((card, index) => (
                  <motion.div
                    className={`lg:h-[90%] flex-[2]`}
                    key={card.id}
                    variants={cardVariants}
                    layout
                  >
                    <Card
                      topCard
                      gradient={card.id === 1 || card.id === 2 || card.id === 3}
                      key={card.id}
                      {...card}
                      onClick={() => redirect(card.id, card.title)}
                    />
                  </motion.div>
                ))}
              </AnimatePresence>
            </motion.div>
          ) : (
            <>
              {mfbasketState === 'loading' && (
                <motion.div
                  className='rounded-xl overflow-hidden border bg-gradient-to-r from-blue-50 via-purple-50 to-pink-50 p-6'
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.3 }}
                >
                  <Skeleton className='h-8 w-40 mb-4 z-10 bg-gradient-to-r from-blue-100 via-purple-100 to-pink-100' />
                  <Skeleton className='h-5 w-64 z-10 bg-gradient-to-r from-blue-100 via-purple-100 to-pink-100' />
                </motion.div>
              )}
            </>
          )}
        </motion.div>

        <motion.div
          className='lg:flex gap-4 lg:max-w-[1128px] mt-6'
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.3 }}
        >
          {/* In mobile view: 2025 Returns and Goal Planning take full width */}
          {!isDesktop && (
            <>
              {/* 2025 Returns card - full width on mobile */}
              {bottomCards.find((card) => card.id === 4) && (
                <motion.div
                  className='w-full mb-4'
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5, duration: 0.25 }}
                >
                  <Card
                    bottomCard
                    key={4}
                    {...bottomCards.find((card) => card.id === 4)}
                    onClick={() => redirect(4)}
                  />
                </motion.div>
              )}

              {/* Goal Planning card - full width on mobile */}
              {bottomCards.find((card) => card.id === 5) && (
                <motion.div
                  className='w-full mb-4'
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.6, duration: 0.25 }}
                >
                  <Card
                    bottomCard
                    key={5}
                    {...bottomCards.find((card) => card.id === 5)}
                    onClick={() => redirect(5)}
                  />
                </motion.div>
              )}

              {/* Insurance and Tax Planning in a 2x2 grid */}
              <motion.div
                className='grid grid-cols-2 gap-4'
                variants={containerVariants}
                initial='hidden'
                animate='visible'
              >
                {bottomCards
                  .filter((card) => card.id === 6 || card.id === 7)
                  .map((card) => (
                    <motion.div key={card.id} variants={cardVariants}>
                      <Card bottomCard {...card} onClick={() => redirect(card.id)} />
                    </motion.div>
                  ))}
              </motion.div>
            </>
          )}

          {/* Desktop view: all cards in a single row */}
          {isDesktop && (
            <motion.div
              className='flex gap-4 w-full'
              variants={containerVariants}
              initial='hidden'
              animate='visible'
            >
              {bottomCardsDesktop.map((card) => (
                <motion.div className='flex-1 h-full' key={card.id} variants={cardVariants}>
                  <Card bottomCard key={card.id} {...card} onClick={() => redirect(card.id)} />
                </motion.div>
              ))}
            </motion.div>
          )}
        </motion.div>

        <AnimatePresence>
          {carouselCards.state === 'hasValue' && carouselCards.state !== 'hasError' ? (
            <motion.div
              className='lg:max-w-[1128px] mt-10'
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.7, duration: 0.3 }}
              exit={{ opacity: 0 }}
            >
              <motion.h1
                className='font-semibold text-lg'
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.8, duration: 0.25 }}
              >
                Understand your Money
              </motion.h1>

              <motion.div
                className='flex flex-col gap-y-5 mt-6'
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.9, duration: 0.25 }}
              >
                <PlansCarousel newPage contentCarouselData={carouselCards.contents} />
              </motion.div>
            </motion.div>
          ) : (
            <motion.div
              className='mb-6'
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8, duration: 0.25 }}
              exit={{ opacity: 0 }}
            >
              {/* Understand your money section */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.9, duration: 0.25 }}
              >
                <Skeleton className='h-8 w-30 lg:w-64 mb-6' />
                <div className='flex gap-x-6 justify-between overflow-x-hidden'>
                  <Skeleton className='h-48 w-full rounded-xl' />
                  <Skeleton className='hidden md:block h-48 w-full rounded-xl' />
                  <Skeleton className='hidden lg:block h-48 w-full rounded-xl' />
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </>
  )
}

export default KycUserHomePage
